import React from 'react';

import classes from './Spinner.module.scss';

interface Props {
    size: number;
    inverse?: boolean;
    center?: boolean;
}

export default function Spinner({ size, inverse, center }: Props) {
    return (
        <div
            style={{ width: `${size}px`, height: `${size}px` }}
            className={`${classes.spinner} ${inverse && classes.inverse} ${
                center && classes.center
            }`}
        ></div>
    );
}
